/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevAutoCalcLogFilter
 */
export interface DevAutoCalcLogFilter {
    /**
     * 
     * @type {string}
     * @memberof DevAutoCalcLogFilter
     */
    runKey: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DevAutoCalcLogFilter
     */
    priceUnitIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DevAutoCalcLogFilter
     */
    productIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevAutoCalcLogFilter
     */
    categories?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevAutoCalcLogFilter
     */
    reasons?: Array<string> | null;
}

/**
 * Check if a given object implements the DevAutoCalcLogFilter interface.
 */
export function instanceOfDevAutoCalcLogFilter(value: object): value is DevAutoCalcLogFilter {
    if (!('runKey' in value) || value['runKey'] === undefined) return false;
    return true;
}

export function DevAutoCalcLogFilterFromJSON(json: any): DevAutoCalcLogFilter {
    return DevAutoCalcLogFilterFromJSONTyped(json, false);
}

export function DevAutoCalcLogFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevAutoCalcLogFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'runKey': json['runKey'],
        'priceUnitIds': json['priceUnitIds'] == null ? undefined : json['priceUnitIds'],
        'productIds': json['productIds'] == null ? undefined : json['productIds'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
    };
}

export function DevAutoCalcLogFilterToJSON(json: any): DevAutoCalcLogFilter {
    return DevAutoCalcLogFilterToJSONTyped(json, false);
}

export function DevAutoCalcLogFilterToJSONTyped(value?: DevAutoCalcLogFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runKey': value['runKey'],
        'priceUnitIds': value['priceUnitIds'],
        'productIds': value['productIds'],
        'categories': value['categories'],
        'reasons': value['reasons'],
    };
}

